import axios from 'axios';

export const fetchLocationByPincode = async (pincode) => {
  try {
    if (!pincode || pincode.length !== 6) {
      return null;
    }

    const response = await axios.get(`https://api.postalpincode.in/pincode/${pincode}`);
    const data = response.data?.[0];
    
    if (data && data.Status === 'Success' && data.PostOffice?.length > 0) {
      const postOffice = data.PostOffice[0];
      return {
        city: postOffice.District || '',
        state: postOffice.State || '',
        area: postOffice.Name || '',
        region: postOffice.Region || '',
        division: postOffice.Division || '',
        country: postOffice.Country || 'India'
      };
    }
    
    return null;
  } catch (error) {
    console.error('Error fetching location by pincode:', error);
    return null;
  }
};

export const validatePincode = (pincode) => {
  const pincodeRegex = /^[1-9][0-9]{5}$/;
  return pincodeRegex.test(pincode);
};